<script>
    import {formatDate} from "../lib/lib";
    import PriceControl from "../components/controls/PriceControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";
    import {OBJECTS} from "../lib/constants";

    export let charge = null;
    export let disableName = false;
    export let disablePrice = false;

    let isPaidOff = false;

    // const showCharge = () => {
    //     showComponent = true;
    //     if (!charge) {
    //         let name = "";
    //         if (objectType == OBJECTS.SUBSCRIPTION) {
    //             name = "Ανανέωση";
    //             if (wsService) {
    //                 name+= " " + wsService.name;
    //             }
    //             name+= " " + chargeObject.name;
    //             name+= ` (${formatDate(chargeObject.start_at, 'd-m-y')} - ${formatDate(chargeObject.end_at, 'd-m-y')})`;
    //         }
    //         charge = {
    //             id: 0,
    //             object_type: objectType,
    //             name,
    //             price: chargeObject.price || null,
    //         }
    //     }
    // }

    const closeCharge = () => {
        // if (charge && charge.id > 0) {
        //     let prompt = "Να αφαιρεθεί η χρέωση";
        //     if (objectType == OBJECTS.SUBSCRIPTION) {
        //         prompt+= " από την υπηρεσία";
        //     }
        //
        //     Alert.confirm("Αφαίρεση χρέωσης", `${prompt};`, () => {
        //         charge = null;
        //     });
        //     return;
        // }
        //
        // charge = null;
        // showComponent = false;
    }

    const onPayOff = () => {
        if (charge.price) {
            charge.payment = charge.price;
            charge.payed_at = formatDate(new Date(), 'y-m-d H:i');
        }
    }


    $: {
        if (charge) {
            isPaidOff = charge.payment > 0 && charge.payment == charge.price;
            if (charge.payment) {
                if (!charge.payed_at) {
                    charge.payed_at = formatDate(new Date(), 'y-m-d H:i');
                }
            } else {
                charge.payed_at = null;
            }
        }
    }
</script>

{#if charge != null}
    <div class="form-group">
        <input type="text" class="form-control" bind:value={charge.name} disabled="{disableName}">
    </div>
    <div class="row">
        <div class="col-6 form-group">
            <label>Χρέωση</label>
            <PriceControl id="charge-price" bind:value="{ charge.price }" required disabled={disablePrice}/>
            {#if !isPaidOff}
                <div class="btn btn-link ps-0" on:click={ onPayOff }>εξόφληση</div>
            {/if}
        </div>
        <div class="col-6 form-group">
            <label>Πληρωμή</label>
            <PriceControl id="charge-payment" bind:value="{ charge.payment }"/>
        </div>
    </div>
    <div class="form-group">
        <label>Ημερομηνία πληρωμής</label>
        <input type="datetime-local" class="form-control" id="charge-payed_at" bind:value="{ charge.payed_at }"
               disabled="{ !charge.payment }">
    </div>
    <div class="form-group">
        <textarea class="form-control" bind:value="{ charge.notes }" placeholder="σημειώσεις"></textarea>
    </div>
{/if}